/* Generate this object in a C# .Net environment like https://dotnetfiddle.net/
using System;
using System.Linq;
					
public class Program
{
	public static void Main()
	{
		System.Globalization.CultureInfo[] allCultures = System.Globalization.CultureInfo.GetCultures(System.Globalization.CultureTypes.NeutralCultures);
		var json = "{" + allCultures
			.GroupBy(c => c.TwoLetterISOLanguageName)
			.Select(g => "\n\t" + g.Key + ":" + new String(' ', 4 - g.Key.Length)
				+ "{"
					+ "name: \"" + g.First().EnglishName + "\", "
					+ "nativeName: \"" + g.First().NativeName + "\""
					+ (g.First().TextInfo.IsRightToLeft ? ", isRightToLeft: true" : "")
				+ "}")
			.Aggregate((a, b) => a + ", " + b)+ "\n}";
		Console.WriteLine(json);
	}
} */
    export const CULTURE_INFO: {
        [code: string]: { name: string; name_fr: string; nativeName: string; isRightToLeft?: boolean };
    } = {
        iv: {
            name: "Invariant Language (Invariant Country)",
            name_fr: "Langue invariante (Pays invariant)",
            nativeName: "Invariant Language (Invariant Country)",
        },
        aa: { name: "Afar", name_fr: "Afar", nativeName: "Afaraf" },
        ab: { name: "Abkhazian", name_fr: "Abkhaze", nativeName: "Аҧсуа" },
        ae: { name: "Avestan", name_fr: "Avestique", nativeName: "Avesta" },
        af: { name: "Afrikaans", name_fr: "Afrikaans", nativeName: "Afrikaans" },
        agq: { name: "Aghem", name_fr: "Aghem", nativeName: "Aghem" },  
        ak: { name: "Akan", name_fr: "Akan", nativeName: "Akan" },
        am: { name: "Amharic", name_fr: "Amharique", nativeName: "አማርኛ" },
        an: { name: "Aragonese", name_fr: "Aragonais", nativeName: "Aragonés" },
        ar: { name: "Arabic", name_fr: "Arabe", nativeName: "العربية", isRightToLeft: true },
        as: { name: "Assamese", name_fr: "Assamais", nativeName: "অসমীয়া" },
        av: { name: "Avaric", name_fr: "Avar", nativeName: "авар мацӀ" },
        ay: { name: "Aymara", name_fr: "Aymara", nativeName: "Aymar aru" },
        az: { name: "Azerbaijani", name_fr: "Azéri", nativeName: "Azərbaycan dili" },
        ba: { name: "Bashkir", name_fr: "Bachkir", nativeName: "башҡорт теле" },
        be: { name: "Belarusian", name_fr: "Biélorusse", nativeName: "Беларуская" },
        bg: { name: "Bulgarian", name_fr: "Bulgare", nativeName: "български език" },
        bh: { name: "Bihari", name_fr: "Bihari", nativeName: "भोजपुरी" },
        bi: { name: "Bislama", name_fr: "Bichelamar", nativeName: "Bislama" },
        bm: { name: "Bambara", name_fr: "Bambara", nativeName: "Bamanankan" },
        bn: { name: "Bengali", name_fr: "Bengalî", nativeName: "বাংলা" },
        bo: { name: "Tibetan", name_fr: "Tibétain", nativeName: "བོད་ཡིག" },
        br: { name: "Breton", name_fr: "Breton", nativeName: "Brezhoneg" },
        bs: { name: "Bosnian", name_fr: "Bosnien", nativeName: "Bosanski jezik" },
        ca: { name: "Catalan", name_fr: "Catalan", nativeName: "Català" },
        ce: { name: "Chechen", name_fr: "Tchétchène", nativeName: "нохчийн мотт" },
        ch: { name: "Chamorro", name_fr: "Chamorro", nativeName: "Chamoru" },
        co: { name: "Corsican", name_fr: "Corse", nativeName: "Corsu" },
        cr: { name: "Cree", name_fr: "Cri", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ" },
        cs: { name: "Czech", name_fr: "Tchèque", nativeName: "Čeština" },
        cu: { name: "Old Church Slavonic", name_fr: "Vieux slave", nativeName: "ѩзыкъ словѣньскъ" },
        cv: { name: "Chuvash", name_fr: "Tchouvache", nativeName: "чӑваш чӗлхи" },
        cy: { name: "Welsh", name_fr: "Gallois", nativeName: "Cymraeg" },
        da: { name: "Danish", name_fr: "Danois", nativeName: "Dansk" },
        de: { name: "German", name_fr: "Allemand", nativeName: "Deutsch" },
        dv: { name: "Dhivehi", name_fr: "Divehi", nativeName: "ދިވެހި" },
        dz: { name: "Dzongkha", name_fr: "Dzongkha", nativeName: "རྫོང་ཁ" },
        ee: { name: "Ewe", name_fr: "Ewe", nativeName: "Eʋegbe" },
        el: { name: "Greek", name_fr: "Grec moderne", nativeName: "Ελληνικά" },
        en: { name: "English", name_fr: "Anglais", nativeName: "English" },
        eo: { name: "Esperanto", name_fr: "Espéranto", nativeName: "Esperanto" },
        es: { name: "Spanish", name_fr: "Espagnol", nativeName: "Español" },
        et: { name: "Estonian", name_fr: "Estonien", nativeName: "Eesti keel" },
        eu: { name: "Basque", name_fr: "Basque", nativeName: "Euskara" },
        fa: { name: "Persian", name_fr: "Persan", nativeName: "فارسی", isRightToLeft: true },
        ff: { name: "Fulah", name_fr: "Peul", nativeName: "Fulfulde" },
        fi: { name: "Finnish", name_fr: "Finnois", nativeName: "Suomen kieli" },
        fj: { name: "Fijian", name_fr: "Fidjien", nativeName: "Vosa Vakaviti" },
        fo: { name: "Faroese", name_fr: "Féringien", nativeName: "Føroyskt" },
        fr: { name: "French", name_fr: "Français", nativeName: "Français" },
        fy: { name: "Western Frisian", name_fr: "Frison occidental", nativeName: "Frysk" },
        ga: { name: "Irish", name_fr: "Irlandais", nativeName: "Gaeilge" },
        gd: { name: "Scottish Gaelic", name_fr: "Gaélique écossais", nativeName: "Gàidhlig" },
        gl: { name: "Galician", name_fr: "Galicien", nativeName: "Galego" },
        gn: { name: "Guarani", name_fr: "Guarani", nativeName: "Avañe'ẽ" },
        gu: { name: "Gujarati", name_fr: "Gujarati", nativeName: "ગુજરાતી" },
        gv: { name: "Manx", name_fr: "Mannois", nativeName: "Gaelg" },
        ha: { name: "Hausa", name_fr: "Haoussa", nativeName: "هَوُسَ" },
        he: { name: "Hebrew", name_fr: "Hébreu", nativeName: "עברית", isRightToLeft: true },
        hi: { name: "Hindi", name_fr: "Hindi", nativeName: "हिन्दी" },
        ho: { name: "Hiri Motu", name_fr: "Hiri motu", nativeName: "Hiri Motu" },
        hr: { name: "Croatian", name_fr: "Croate", nativeName: "Hrvatski" },
        ht: { name: "Haitian Creole", name_fr: "Créole haïtien", nativeName: "Kreyòl ayisyen" },
        hu: { name: "Hungarian", name_fr: "Hongrois", nativeName: "Magyar" },
        hy: { name: "Armenian", name_fr: "Arménien", nativeName: "Հայերեն" },
        hz: { name: "Herero", name_fr: "Herero", nativeName: "Otjiherero" },
        ia: { name: "Interlingua", name_fr: "Interlingua", nativeName: "Interlingua" },
        id: { name: "Indonesian", name_fr: "Indonésien", nativeName: "Bahasa Indonesia" },
        ie: { name: "Interlingue", name_fr: "Interlingue", nativeName: "Interlingue" },
        ig: { name: "Igbo", name_fr: "Igbo", nativeName: "Igbo" },
        ii: { name: "Sichuan Yi", name_fr: "Yi", nativeName: "ꆇꉙ" },
        ik: { name: "Inupiaq", name_fr: "Inupiaq", nativeName: "Iñupiaq" },
        io: { name: "Ido", name_fr: "Ido", nativeName: "Ido" },
        is: { name: "Icelandic", name_fr: "Islandais", nativeName: "Íslenska" },
        it: { name: "Italian", name_fr: "Italien", nativeName: "Italiano" },
        iu: { name: "Inuktitut", name_fr: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ" },
        ja: { name: "Japanese", name_fr: "Japonais", nativeName: "日本語(にほんご)" },
        jv: { name: "Javanese", name_fr: "Javanais", nativeName: "Basa Jawa" },
        ka: { name: "Georgian", name_fr: "Géorgien", nativeName: "ქართული" },
        kg: { name: "Kongo", name_fr: "Kikongo", nativeName: "Kikongo" },
        ki: { name: "Kikuyu", name_fr: "Kikuyu", nativeName: "Gĩkũyũ" },
        kj: { name: "Kwanyama", name_fr: "Kuanyama", nativeName: "Kuanyama" },
        kk: { name: "Kazakh", name_fr: "Kazakh", nativeName: "Қазақ тілі" },
        kl: { name: "Kalaallisut", name_fr: "Kalaallisut", nativeName: "Kalaallisut" },
        km: { name: "Khmer", name_fr: "Khmer", nativeName: "ភាសាខ្មែរ" },
        kmr: { name: "Northern Kurdish", name_fr: "Kurde du Nord", nativeName: "Kurdî (bakur)" },
        kn: { name: "Kannada", name_fr: "Kannada", nativeName: "ಕನ್ನಡ" },
        ko: { name: "Korean", name_fr: "Coréen", nativeName: "한국어" },
        kr: { name: "Kanuri", name_fr: "Kanouri", nativeName: "Kanuri" },
        ks: { name: "Kashmiri", name_fr: "Kashmiri", nativeName: "कश्मीरी" },
        ku: { name: "Kurdish", name_fr: "Kurde", nativeName: "Kurdî" },
        kv: { name: "Komi", name_fr: "Komi", nativeName: "Коми кыв" },
        kw: { name: "Cornish", name_fr: "Cornique", nativeName: "Kernewek" },
        ky: { name: "Kyrgyz", name_fr: "Kirghiz", nativeName: "Кыргызча" },
        la: { name: "Latin", name_fr: "Latin", nativeName: "Latina" },
        lb: { name: "Luxembourgish", name_fr: "Luxembourgeois", nativeName: "Lëtzebuergesch" },
        lg: { name: "Ganda", name_fr: "Ganda", nativeName: "Luganda" },
        li: { name: "Limburgish", name_fr: "Limbourgeois", nativeName: "Limburgs" },
        ln: { name: "Lingala", name_fr: "Lingala", nativeName: "Lingála" },
        lo: { name: "Lao", name_fr: "Lao", nativeName: "ພາສາລາວ" },
        lt: { name: "Lithuanian", name_fr: "Lituanien", nativeName: "Lietuvių kalba" },
        lu: { name: "Luba-Katanga", name_fr: "Luba-Katanga", nativeName: "cilubà" },
        lv: { name: "Latvian", name_fr: "Letton", nativeName: "Latviešu valoda" },
        mg: { name: "Malagasy", name_fr: "Malgache", nativeName: "Malagasy" },
        mh: { name: "Marshallese", name_fr: "Marshallais", nativeName: "Kajin M̧ajeļ" },
        mi: { name: "Maori", name_fr: "Maori", nativeName: "Te reo Māori" },
        mk: { name: "Macedonian", name_fr: "Macédonien", nativeName: "македонски јазик" },
        ml: { name: "Malayalam", name_fr: "Malayalam", nativeName: "മലയാളം" },
        mn: { name: "Mongolian", name_fr: "Mongol", nativeName: "Монгол" },
        mo: { name: "Moldavian", name_fr: "Moldave", nativeName: "лимба молдовеняскэ" },
        mr: { name: "Marathi", name_fr: "Marathi", nativeName: "मराठी" },
        ms: { name: "Malay", name_fr: "Malais", nativeName: "Bahasa Melayu" },
        mt: { name: "Maltese", name_fr: "Maltais", nativeName: "Malti" },
        my: { name: "Burmese", name_fr: "Birman", nativeName: "ဗမာစာ" },
        na: { name: "Nauruan", name_fr: "Nauruan", nativeName: "Dorerin Naoero" },
        nb: { name: "Norwegian Bokmål", name_fr: "Norvégien Bokmål", nativeName: "Norsk Bokmål" },
        nd: { name: "North Ndebele", name_fr: "Ndébélé du Nord", nativeName: "isiNdebele" },
        ne: { name: "Nepali", name_fr: "Népalais", nativeName: "नेपाली" },
        ng: { name: "Ndonga", name_fr: "Ndonga", nativeName: "Owambo" },
        nl: { name: "Dutch", name_fr: "Néerlandais", nativeName: "Nederlands" },
        nn: { name: "Norwegian Nynorsk", name_fr: "Norvégien Nynorsk", nativeName: "Norsk Nynorsk" },
        no: { name: "Norwegian", name_fr: "Norvégien", nativeName: "Norsk" },
        nr: { name: "South Ndebele", name_fr: "Ndébélé du Sud", nativeName: "Ndébélé" },
        nv: { name: "Navajo", name_fr: "Navajo", nativeName: "Diné bizaad" },
        ny: { name: "Chichewa", name_fr: "Chichewa", nativeName: "ChiCheŵa" },
        oc: { name: "Occitan", name_fr: "Occitan", nativeName: "Occitan" },
        oj: { name: "Ojibwa", name_fr: "Ojibwé", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
        om: { name: "Oromo", name_fr: "Oromo", nativeName: "Afaan Oromoo" },
        or: { name: "Odia", name_fr: "Odia", nativeName: "ଓଡ଼ିଆ" },
        os: { name: "Ossetian", name_fr: "Ossète", nativeName: "Ирон æвзаг" },
        pa: { name: "Punjabi", name_fr: "Pendjabi", nativeName: "ਪੰਜਾਬੀ" },
        pi: { name: "Pali", name_fr: "Pali", nativeName: "पालि" },
        pl: { name: "Polish", name_fr: "Polonais", nativeName: "Polski" },
        ps: { name: "Pashto", name_fr: "Pachto", nativeName: "پښتو", isRightToLeft: true },
        pt: { name: "Portuguese (Brazil)", name_fr: "Portugais (Brésil)", nativeName: "Português (Brasil)" },
        qu: { name: "Quechua", name_fr: "Quechua", nativeName: "Runa Simi" },
        rm: { name: "Romansh", name_fr: "Romanche", nativeName: "Rumantsch" },
        rn: { name: "Kirundi", name_fr: "Kirundi", nativeName: "kiRundi" },
        ro: { name: "Romanian", name_fr: "Roumain", nativeName: "Română" },
        ru: { name: "Russian", name_fr: "Russe", nativeName: "русский язык" },
        rw: { name: "Kinyarwanda", name_fr: "Kinyarwanda", nativeName: "Kinyarwanda" },
        sa: { name: "Sanskrit", name_fr: "Sanskrit", nativeName: "संस्कृतम्" },
        sc: { name: "Sardinian", name_fr: "Sarde", nativeName: "Sardu" },
        sd: { name: "Sindhi", name_fr: "Sindhi", nativeName: "سنڌي", isRightToLeft: true },
        se: { name: "Northern Sami", name_fr: "Same du Nord", nativeName: "Davvisámegiella" },
        sg: { name: "Sango", name_fr: "Sango", nativeName: "Yângâ tî sängö" },
        sh: { name: "Serbo-Croatian", name_fr: "Serbo-croate", nativeName: "Српскохрватски" },
        si: { name: "Sinhala", name_fr: "Cingalais", nativeName: "සිංහල" },
        sk: { name: "Slovak", name_fr: "Slovaque", nativeName: "Slovenčina" },
        sl: { name: "Slovenian", name_fr: "Slovène", nativeName: "Slovenščina" },
        sm: { name: "Samoan", name_fr: "Samoan", nativeName: "Gagana fa'a Samoa" },
        sn: { name: "Shona", name_fr: "Shona", nativeName: "chiShona" },
        so: { name: "Somali", name_fr: "Somali", nativeName: "Soomaaliga" },
        sq: { name: "Albanian", name_fr: "Albanais", nativeName: "Shqip" },
        sr: { name: "Serbian", name_fr: "Serbe", nativeName: "српски језик" },
        ss: { name: "Swati", name_fr: "Swati", nativeName: "SiSwati" },
        st: { name: "Southern Sotho", name_fr: "Sotho du Sud", nativeName: "Sesotho" },
        su: { name: "Sundanese", name_fr: "Soundanais", nativeName: "Basa Sunda" },
        sv: { name: "Swedish", name_fr: "Suédois", nativeName: "Svenska" },
        sw: { name: "Swahili", name_fr: "Swahili", nativeName: "Kiswahili" },
        ta: { name: "Tamil", name_fr: "Tamoul", nativeName: "தமிழ்" },
        te: { name: "Telugu", name_fr: "Télougou", nativeName: "తెలుగు" },
        tg: { name: "Tajik", name_fr: "Tadjik", nativeName: "Тоҷикӣ" },
        th: { name: "Thai", name_fr: "Thaï", nativeName: "ไทย" },
        ti: { name: "Tigrinya", name_fr: "Tigrigna", nativeName: "ትግርኛ" },
        tk: { name: "Turkmen", name_fr: "Turkmène", nativeName: "Türkmen" },
        tl: { name: "Tagalog", name_fr: "Tagalog", nativeName: "Wikang Tagalog" },
        tn: { name: "Tswana", name_fr: "Tswana", nativeName: "Setswana" },
        to: { name: "Tongan", name_fr: "Tongien", nativeName: "Lea faka-Tonga" },
        tr: { name: "Turkish", name_fr: "Turc", nativeName: "Türkçe" },
        ts: { name: "Tsonga", name_fr: "Tsonga", nativeName: "Xitsonga" },
        tt: { name: "Tatar", name_fr: "Tatar", nativeName: "Татарча" },
        tw: { name: "Twi", name_fr: "Twi", nativeName: "Twi" },
        ty: { name: "Tahitian", name_fr: "Tahitien", nativeName: "Reo Mā`ohi" },
        ug: { name: "Uyghur", name_fr: "Ouïghour", nativeName: "ئۇيغۇرچە", isRightToLeft: true },
        uk: { name: "Ukrainian", name_fr: "Ukrainien", nativeName: "Українська" },
        ur: { name: "Urdu", name_fr: "Ourdou", nativeName: "اردو", isRightToLeft: true },
        uz: { name: "Uzbek", name_fr: "Ouzbek", nativeName: "Oʻzbek" },
        ve: { name: "Venda", name_fr: "Venda", nativeName: "Tshivenḓa" },
        vi: { name: "Vietnamese", name_fr: "Vietnamien", nativeName: "Tiếng Việt" },
        vo: { name: "Volapük", name_fr: "Volapük", nativeName: "Volapük" },
        wa: { name: "Walloon", name_fr: "Wallon", nativeName: "Walon" },
        wo: { name: "Wolof", name_fr: "Wolof", nativeName: "Wollof" },
        xh: { name: "Xhosa", name_fr: "Xhosa", nativeName: "isiXhosa" },
        yi: { name: "Yiddish", name_fr: "Yiddish", nativeName: "ייִדיש", isRightToLeft: true },
        yo: { name: "Yoruba", name_fr: "Yoruba", nativeName: "Yorùbá" },
        za: { name: "Zhuang", name_fr: "Zhuang", nativeName: "Saɯ cueŋƅ" },
        zh: { name: "Chinese", name_fr: "Chinois", nativeName: "中文, 汉语, 漢語"},
        zu: { name: "Zulu", name_fr: "Zoulou", nativeName: "isiZulu" },
        prs: { name: "Dari", name_fr: "Dari", nativeName: "دری", isRightToLeft: true },
        yue: { name: "Cantonese", name_fr: "Cantonais", nativeName: "廣東話" },
        fil: { name: "Filipino", name_fr: "Filipino", nativeName: "Filipino" },
        mww: { name: "Hmong Daw", name_fr: "Hmong blanc", nativeName: "Hmoob Dawb" },
        ikt: { name: "Inuinnaqtun", name_fr: "Inuinnaqtun", nativeName: "Inuinnaqtun" },
        "tlh-latn": { name: "Klingon (Latin)", name_fr: "Klingon (latin)", nativeName: "tlhIngan Hol" },
        "tlh-piqd": { name: "Klingon (pIqaD)", name_fr: "Klingon (pIqaD)", nativeName: "tlhIngan Hol (pIqaD)" },
        yua: { name: "Yucatec Maya", name_fr: "Maya yucatèque", nativeName: "Maaya t'aan" },
        "fr-ca": { name: "Canadian French", name_fr: "Français canadien", nativeName: "Français canadien" },
        "iu-latn": { name: "Inuktitut (Latin)", name_fr: "Inuktitut (latin)", nativeName: "Inuktitut (latin)" },
        "pt-pt": { name: "Portuguese (Portugal)", name_fr: "Portugais (Portugal)", nativeName: "Português (Portugal)" },
        "zh-hans": { name: "Chinese (Simplified)", name_fr: "Chinois simplifié", nativeName: "简体中文" },
        "zh-hant": { name: "Chinese (Traditional)", name_fr: "Chinois traditionnel", nativeName: "繁體中文" },
        lzh: { name: "Chinese (Classical)", name_fr: "Chinois classique", nativeName: "文言" },
        "mn-cyrl": { name: "Mongolian (Cyrillic)", name_fr: "Mongol (cyrillique)", nativeName: "Монгол (кирилл)" },
        "mn-mong": { name: "Mongolian (Traditional)", name_fr: "Mongol (traditionnel)", nativeName: "ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ" },
        "sr-cyrl": { name: "Serbian (Cyrillic)", name_fr: "Serbe (cyrillique)", nativeName: "Српски (ћирилица)" },
        "sr-latn": { name: "Serbian (Latin)", name_fr: "Serbe (latin)", nativeName: "Srpski (latinica)" },
        vl: { name: "Flemish", name_fr: "Flamand", nativeName: "Vlaams" }
    };
    